import React, { useCallback, useEffect, useMemo, useState } from 'react'
import logo from "../../Assets/images/main-logo.svg"
import mainLogoShort from '../../Assets/images/cms-logo.png';
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import { useDispatch, useSelector } from 'react-redux'
import { ProfileAction } from '../../redux/Action/Authaction'
import { Link, NavLink } from 'react-router-dom'
import Swal from 'sweetalert2'
import { ApiTypes, PAGINATION, StorageConstant, VALIDATION_MESSAGE } from '../../constants/Constants'
import { Modal } from 'react-bootstrap'
import DeleteAccount from '../../Modal/DeleteAccount'
import { deleteFromStorage, getFromStorage, saveUsdToEurRateToStorage } from '../../utils/Helper'
import { invalidatePendingDashboardBootstrapCache } from '../../utils/pendingDashboardBootstrap'
import { Config } from '../../config/Config'
import { LanguageConstants } from '../../constants/LanguageConstants'
import { ensureBusinessProfileAllowsQuote } from '../../utils/quoteAccessGate'
import RequestQuoteModal from '../../Modal/RequestQuoteModalImpl'
import ContactusModal from '../../Modal/ContactusModal'
import BrandedLoaderOverlay from './BrandedLoaderOverlay'
import LanguageDropdown from './LanguageDropdown'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { Routes as AppRoutes } from '../../constants/RouteConstants'
import { getAppRouterPath } from '../../utils/quotationCheckout'
import { isCompleteProfilePath, needsSocialProfileCompletion } from '../../utils/socialProfileCompletion'

function Header() {
  const location = useLocation()
  const { state } = useLocation();
  const navigate = useNavigate()
  const [quoteshow, setQuoteshow] = useState(false)
  const [contacShow, setContactShow] = useState(false)
  const [data, setData] = useState<any>({})
  const dispatch = useDispatch()
  const profiledata = useSelector((state: any) => state?.ProfileState)
  const Logout = useMakeRequest()
  const currencyGet = useMakeRequest()
  const [deleteShow, setDeleteShow] = useState(false)
  const isLoggedIn = Boolean(profiledata?.data?.data);
  const showMainNav = isLoggedIn && location.pathname !== '/category';
  const deleteAccount = useMakeRequest();
  const notificationList = useMakeRequest();
  const [notifCount, setNotifCount] = useState(0);
  const notifDetail = profiledata?.data?.data?.notification_detail;

const notifIds = (notifDetail as any)?.notification_ids;
const [headerScrolled, setHeaderScrolled] = useState(false);

useEffect(() => {
  const onScroll = () => setHeaderScrolled(window.scrollY > 12);
  window.addEventListener('scroll', onScroll, { passive: true });
  return () => window.removeEventListener('scroll', onScroll);
}, []);





  const hasUnreadNotification = Array.isArray(notifDetail)
    ? notifDetail.some((item: any) => String(item?.is_unread_notification) === "1")
    : String(notifDetail?.is_unread_notification) === "1";

  useEffect(() => {
    const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN })
    currencyGet.makeRequest({ url: ApiConstants?.currencyget, type: ApiTypes.GET, toastStatus: false })
    if (token && !profiledata?.data?.data) {
      // @ts-ignore
      dispatch(ProfileAction())
    }
  }, [])

  useEffect(() => {
    if (!isLoggedIn) {
      setNotifCount(0)
      return
    }
    const payload = {
      page: PAGINATION?.PAGE,
      pageSize: 200,
    }
    notificationList.makeRequest({ payload, url: ApiConstants?.NotificationList, toastStatus: false })
  }, [isLoggedIn])

  useEffect(() => {
    if (!notificationList?.status) return
    const rows = notificationList?.data?.data?.rows || []
    const apiUnread = Number(notificationList?.data?.data?.unread_notification_count)
    const unreadCount = Number.isFinite(apiUnread)
      ? apiUnread
      : rows.filter((item: any) => String(item?.is_read) === "0").length
    setNotifCount(unreadCount)
    window.dispatchEvent(new CustomEvent("notification:refresh"))
  }, [notificationList?.status, notificationList?.data])

  const refreshNotificationBadge = useCallback(() => {
    if (!isLoggedIn) return;
    notificationList.makeRequest({
      payload: { page: PAGINATION?.PAGE, pageSize: 200 },
      url: ApiConstants?.NotificationList,
      toastStatus: false,
    });
  }, [isLoggedIn, notificationList.makeRequest]);

  useEffect(() => {
    const handleNotificationRead = (event: Event) => {
      const customEvent = event as CustomEvent<{ decrementBy?: number; setUnreadTo?: number }>;
      if (typeof customEvent?.detail?.setUnreadTo === "number") {
        setNotifCount(Math.max(0, customEvent.detail.setUnreadTo));
      } else {
        const decrementBy = customEvent?.detail?.decrementBy ?? 1;
        setNotifCount((prevCount) => Math.max(0, prevCount - decrementBy));
      }
      refreshNotificationBadge();
    };

    window.addEventListener("notification:read", handleNotificationRead as EventListener);
    return () => {
      window.removeEventListener("notification:read", handleNotificationRead as EventListener);
    };
  }, [refreshNotificationBadge]);

  const handleLogout = async () => {
    Swal.fire({
      icon: 'warning',
      title: LanguageConstants?.ARE_YOU_SURE,
      text: LanguageConstants?.YOU_WANT_TO_LOGUT,
      showCancelButton: true,
      cancelButtonText: LanguageConstants?.NO ?? 'No',
      confirmButtonText: LanguageConstants?.YES,
      showCloseButton: true,
      buttonsStyling: false,
      reverseButtons: true,
      customClass: {
        container: 'logout-com-modal-wrap',
        popup: 'logout-com-modal',
        title: 'logout-com-modal__title',
        closeButton: 'logout-com-modal__close',
        htmlContainer: 'logout-com-modal__html',
        actions: 'logout-com-modal__footer',
        confirmButton: 'logout-com-modal__btn logout-com-modal__btn--confirm com-btn',
        cancelButton: 'logout-com-modal__btn logout-com-modal__btn--cancel com-btn com-btn-outline',
      },
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        Logout.makeRequest({ url: ApiConstants?.LogOut, toastStatus: true })
        invalidatePendingDashboardBootstrapCache()
        deleteFromStorage({ key: "access_token", type: 'local' })
        deleteFromStorage({ key: "currencyValue", type: 'local' })
        deleteFromStorage({ key: "eurCurrencyValue", type: 'local' })
        deleteFromStorage({ key: "user_data", type: 'local' })
        window.location.href = `${Config?.BASE_URL}/login`;
      }
    });
  }

  useEffect(() => {
    if (currencyGet?.status) {
      saveUsdToEurRateToStorage(currencyGet?.data?.data);
    }
  }, [currencyGet?.status])

  const handleDeleteClose = () => {
    setDeleteShow(false)
  }

  const navigateToQuote = () => {
    if (!ensureBusinessProfileAllowsQuote(profiledata?.data?.data, navigate, LanguageConstants as any)) {
      return;
    }
    setQuoteshow(true)
  }

  const navigateToQuoteClose = () => {
    setQuoteshow(false)
  }

  const handelContactUsClose = () => {
    setContactShow(false)
  }


  const handelDelete = () => {
    if (profiledata?.data?.data?.social_id) {
      Swal.fire({
        icon: 'warning',
        title: LanguageConstants?.ARE_YOU_SURE,
        text: LanguageConstants?.YOU_WANT_TO_DELETE,
        showCancelButton: true,
        cancelButtonText: LanguageConstants?.NO ?? 'No',
        confirmButtonText: LanguageConstants?.YES,
        showCloseButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          container: 'logout-com-modal-wrap',
          popup: 'logout-com-modal',
          title: 'logout-com-modal__title',
          closeButton: 'logout-com-modal__close',
          htmlContainer: 'logout-com-modal__html',
          actions: 'logout-com-modal__footer',
          confirmButton: 'logout-com-modal__btn logout-com-modal__btn--confirm com-btn',
          cancelButton: 'logout-com-modal__btn logout-com-modal__btn--cancel com-btn com-btn-outline',
        },
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const payload = {
            social_id: profiledata?.data?.data?.social_id
          }
          deleteAccount.makeRequest({ payload, url: ApiConstants?.DeleteAccount, toastStatus: true })
        }
      });
    } else {
      setDeleteShow(true)
    }
  }

  useEffect(() => {
    if (deleteAccount?.status) {
      deleteFromStorage({ key: "access_token", type: 'local' })
      localStorage.clear()
      window.location.href = `${Config?.BASE_URL}/login`;
    }
  }, [deleteAccount?.status])

  useEffect(() => {
    const user = profiledata?.data?.data;
    if (!user) return;
    if (isCompleteProfilePath(location.pathname)) return;
    if (needsSocialProfileCompletion(user)) {
      navigate(AppRoutes.CompleteProfile, { replace: true });
      return;
    }
    if (user?.is_category_select == '0') {
      navigate('/category');
    }
  }, [profiledata, location.pathname, navigate]);

  useEffect(()=>{
  if(state?.data?.modelShow == true){
    setQuoteshow(true)
  }
  },[state?.data?.modelShow])

  const isMyQuotesNavActive = useMemo(() => {
    const p = getAppRouterPath(location.pathname);
    if (p.startsWith("/order-checkout")) return false;
    return (
      p === "/my-quotation" ||
      p.startsWith("/view-quotation") ||
      p.startsWith("/quotation-checkout") ||
      p.startsWith("/quotation-pdf-preview") ||
      p.startsWith("/history/")
    );
  }, [location.pathname]);

  const isMyOrderNavActive = useMemo(() => {
    const p = getAppRouterPath(location.pathname);
    if (p.startsWith("/quotation-checkout")) return false;
    return (
      p === "/order" ||
      p.startsWith("/order-detail") ||
      p.startsWith("/order-checkout")
    );
  }, [location.pathname]);

  return (
    <>
      <BrandedLoaderOverlay active={deleteAccount.loading} />
      <header className={headerScrolled ? 'sticky-header' : ''}>
        <div className="site-fixed-chrome">
          <nav
            className="navbar navbar-expand-lg"
          >
          <div className="container">
            <Link
              className="navbar-brand"
              to={`/`}
            >
              <img className="logo-large" src={logo} alt="Quote N Buy" />
              <img className="logo-short" src={mainLogoShort} alt="Quote N Buy" />
            </Link>
            {profiledata?.data?.data ?
              <a className="com-btn com-btn-outline head-login-btn d-lg-none ms-auto me-2 me-sm-3" onClick={() => handleLogout()} >Logout</a>
              :
              <Link to='/login' className="com-btn com-btn-outline head-login-btn d-lg-none ms-auto me-2 me-sm-3" >Login</Link>
            }
            <button className="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className={`navbar-nav pt-3 pt-lg-0 ${showMainNav ? 'ms-lg-4 ms-xxl-5 me-auto' : 'ms-auto'}`}>
                {showMainNav ? (
                  <>
                    <li className="nav-item">
                      <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
                        {LanguageConstants?.HOME}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to="/my-quotation"
                        className={() => (isMyQuotesNavActive ? "active" : undefined)}
                      >
                        {LanguageConstants?.MYOUESTION}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to="/order"
                        className={() => (isMyOrderNavActive ? "active" : undefined)}
                      >
                        {LanguageConstants?.MYORDER}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink to="/drafts" className={({ isActive }) => (isActive ? 'active' : undefined)}>
                        {LanguageConstants?.DRAFTS}
                      </NavLink>
                    </li>
                  </>
                ) : null}
              </ul>
              <div className="nav-right-side pb-2 pb-lg-0 pt-4 pt-lg-0">
                {!profiledata?.data?.data ?
                  <Link to='/login' className="com-btn com-btn-outline head-login-btn d-lg-flex d-none">{LanguageConstants?.LOGIN}</Link>
                  : null}
                {profiledata?.data?.data &&
                (location?.pathname === '/' ||
                  location?.pathname === '/my-quotation' ||
                  location?.pathname === '/drafts' ||
                  location?.pathname === '/order') ? (
                  <div className="quote-animation-wrap">
                    <button
                      type="button"
                      className="head-start-quote-pill quote-animation"
                      onClick={() => navigateToQuote()}
                    >
                      <span className="word-first">{LanguageConstants?.REQUESTQUOTES}</span>
                      <span className="word-second">{LanguageConstants?.LETS_GO}</span>
                    </button>

                  </div>
                ) : null}
                {profiledata?.data?.data && location?.pathname != '/category' ? (
                  <div className="nav-item header-dropdown">
                    <div className="dropdown-btn">
                      <div className="drop-user">
                        <div className="drop-img">
                          <img
                            src={`${process.env.PUBLIC_URL || ''}/User.png`}
                            alt=""
                          />
                        </div>
                      </div>
                      <i className="arw icon-chev-btm text-dark" aria-hidden />
                      <ul className="drop-list">
                        <li>
                          <Link to="/profile" className="txt">
                            <span>{LanguageConstants?.MY_DETAILS ?? LanguageConstants?.VIEWPROFILE}</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/address" className="txt">
                            <span>{LanguageConstants?.MYADDRESS}</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/update-category" className="txt">
                            <span>{LanguageConstants?.CATEGORY_SELECTION}</span>
                          </Link>
                        </li>
                        {!profiledata?.data?.data?.social_id ? (
                          <li>
                            <Link to={AppRoutes.ChangePassword} className="txt">
                              <span>{LanguageConstants?.CHANGEPASSWORD}</span>
                            </Link>
                          </li>
                        ) : null}
                        <li>
                          <div
                            className="txt"
                            role="button"
                            tabIndex={0}
                            onClick={() => handelDelete()}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handelDelete();
                              }
                            }}
                          >
                            <span>{LanguageConstants?.DELETEACCOUNT}</span>
                          </div>
                        </li>
                        <li>
                          <div
                            className="txt"
                            role="button"
                            tabIndex={0}
                            onClick={() => handleLogout()}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleLogout();
                              }
                            }}
                          >
                            <span>{LanguageConstants?.LOGOUT}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : null}

                {!profiledata?.data?.data ?
                  <Link to='/login' className="head-notify"><i className="icon-bell" />
                  </Link>
                  :
                  <>
                  {location?.pathname !='/category' ? 
                    <Link to='/notification' className="head-notify"><i className="icon-bell" />
                    {/* <span>{notifCount}</span> */}
                      {notifCount > 0 ? (
                        <span className="head-notify__count" aria-label="Notifications">
                          {notifCount > 99 ? '99+' : notifCount}
                        </span>
                      ) : null}
                    </Link>
                    :null}
                  </>
                }
                <LanguageDropdown instanceId="langDropdown" />
              </div>
            </div>
          </div>
        </nav>
          {/* Dashboard Pending Actions portals here — same fixed chrome as the navbar */}
          <div id="dashboard-pending-actions-host" />
        </div>
      </header>

      {/* <!-- Delete account  --> */}
      <Modal show={deleteShow} >
        <DeleteAccount handleClso={handleDeleteClose} />
      </Modal>
      {/* <!-- Delete account  --> */}

      {/* Request Quote modal */}
      <Modal show={quoteshow} >
        <RequestQuoteModal handelClso={navigateToQuoteClose} />
      </Modal>
      {/* Request Quote modal */}

      {/* Contact us modal */}
      <Modal show={contacShow} >
        <ContactusModal handelClso={handelContactUsClose} />
      </Modal>
      {/* Contact us modal */}

    </>
  )
}

export default Header
